import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
import { getConfigDetails } from '../../../services/config'

const ApplePayBtnFS = (props) => {
    const {
        faciltyData,
        getValues,
        setIsSubmittingForm,
        onSubmit,
        applePaySessionRef,
        payableAmount
    } = props
    const [applePayBtm, setApplePayBtm] = useState(false)

    useEffect(() => {
        if (window?.ApplePaySession) {
            if(window?.ApplePaySession.canMakePayments()) {
                setApplePayBtm(true)
            }
        }
    }, [])

    const initializeApplePay = () => {
        // Check if the user's browser supports Apple Pay
        if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
            const paymentRequest = {
                countryCode: 'US',
                currencyCode: 'USD',
                supportedNetworks: ['visa', 'masterCard', 'amex'],
                merchantCapabilities: ['supports3DS'],
                total: { label: 'Your Store', amount: Number(payableAmount)?.toFixed(2) }
            }

            const session = new window.ApplePaySession(3, paymentRequest)
            applePaySessionRef.current = session

            // Validate merchant with your backend PHP script
            session.onvalidatemerchant = (event) => {
                fetch(`${getConfigDetails().baseURL}apple-pay-fiserv/start-merchant-session`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 'merchantIdentifier': faciltyData?.facility_payment_details?.heartland_applepay_identifier,
                        'displayName': faciltyData?.facility_payment_details?.heartland_merchant_name,
                        'initiative': 'web',
                        'initiativeContext': window.location.hostname,
                        'validationURL': event.validationURL,
                        'facility_id': faciltyData?.id
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.error || data.success === false) {
                        console.error('Merchant validation failed', data.message || data.error)
                        session.abort()
                    } else {
                        // Your backend returns the merchant session in data.data
                        const validMerchantData = data.data || data
                        console.log('✅ Merchant validation successful:', validMerchantData)
                        session.completeMerchantValidation(validMerchantData)
                    }
                })
                .catch((error) => {
                    session.abort()
                    console.error('Validation error:', error)
                })
            }

            // Handle payment authorization
            session.onpaymentauthorized = (event) => {
                setIsSubmittingForm(true)
                console.log('event====', event)
                console.log('event?.payment===', event?.payment)
                
                const paymentToken = event?.payment?.token
                // Add paymentMethodInfo directly to formData
                const formData = getValues()
                console.log('formData.paymentMethodInfo===', formData.paymentMethodInfo)
                const payload = {
                    ...formData,
                    walletPay: JSON.stringify(paymentToken?.paymentData),
                    amount: Number(payableAmount)?.toFixed(2),
                    invoice_number: '1234',
                    paymentMethods: 'APL',
                    paymentMethodInfo: paymentToken?.paymentMethod
                }
                onSubmit(payload, 0)
            }

            // Begin the session
            session.begin()
        } else {
            console.log('Apple Pay is not supported on this device.')
        }
    }

    return (
            <div className='px-2 payButton'>
                { applePayBtm ? <button className="apple-pay-button" id="apple-pay-button" onClick={initializeApplePay}>&nbsp;</button> : '' }
            </div>
    )
}

ApplePayBtnFS.propTypes = {
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    dispatch: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setIsConfimationModalOpen: PropTypes.func,
    setIsRateMisMatch: PropTypes.func,
    setMismatchRateError: PropTypes.func,
    setIsTokenApiStart: PropTypes.func,
    notify: PropTypes.func,
    onSubmit: PropTypes.func,
    seletedRateBand: PropTypes.string,
    totalHoursLength: PropTypes.string,
    events: PropTypes.array,
    selectedEv: PropTypes.string,
    qrcodeId: PropTypes.string,
    partner: PropTypes.string,
    isDisplayRateBand: PropTypes.bool,
    loginData: PropTypes.object,
    applePaySessionRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    payableAmount: PropTypes.number,
}
 
ApplePayBtnFS.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    dispatch: noop,
    setIsSubmittingForm: noop,
    setIsConfimationModalOpen: noop,
    setIsRateMisMatch: noop,
    setMismatchRateError: noop,
    setIsTokenApiStart: noop,
    notify: noop,
    onSubmit: noop,
    seletedRateBand: '',
    totalHoursLength: '',
    events: EMPTY_ARRAY,
    selectedEv: '',
    qrcodeId: '',
    partner: '',
    isDisplayRateBand: false,
    loginData: EMPTY_OBJECT,
    applePaySessionRef: null,
    payableAmount: 0,
}

export default ApplePayBtnFS